import React from 'react';
import { ClockIcon, CalendarIcon } from '@radix-ui/react-icons';
import { Card, CardHeader, CardTitle, CardContent } from '../../common/Card';
import { formatInTimezone } from '../../../utils/timezone';

export default function LongestLoggedTimeCard({ data }) {
    const formatDuration = (minutes) => {
        if (minutes >= 60) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours} hour${hours > 1 ? 's' : ''}${remainingMinutes > 0 ? ` ${remainingMinutes} min${remainingMinutes > 1 ? 's' : ''}` : ''}`;
        }
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    };

    if (!data || !data.startedAt) {
        return (
            <Card>
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="flex items-center gap-2 text-sm font-medium">
                        <ClockIcon className="h-4 w-4" />
                        Longest Session
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="flex flex-col items-center justify-center py-6 text-center text-muted-foreground">
                        <p>No sessions recorded yet</p>
                    </div>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="flex items-center gap-2 text-sm font-medium">
                    <ClockIcon className="h-4 w-4" />
                    Longest Session
                </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col items-center justify-center space-y-6">
                {/* Duration Display */}
                <div className="flex flex-col items-center justify-center py-12">
                    <div className="text-5xl font-bold tracking-tight">
                        {formatDuration(data.durationInMinutes)}
                    </div>
                    <p className="text-sm text-muted-foreground mt-1">
                        Longest duration logged for this activity
                    </p>
                </div>

                {/* Time Details */}
                <div className="grid grid-cols-2 gap-6 rounded-lg border p-4 w-full">
                    <div className="space-y-1">
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <CalendarIcon className="h-4 w-4" />
                            Started
                        </div>
                        <p className="font-medium">
                            {formatInTimezone(data.startedAt)}
                        </p>
                    </div>
                    <div className="space-y-1">
                        <div className="flex items-center gap-2 text-sm text-muted-foreground">
                            <CalendarIcon className="h-4 w-4" />
                            Ended
                        </div>
                        <p className="font-medium">
                            {formatInTimezone(data.endedAt)}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
} 